module.exports = __webpack_public_path__ + "media/packs/images/flags/BJ-740e646dd44f5db4db131e02a4e45f59.png";